<div class="PGQRCode d-flex justify-content-center" role="img" [attr.aria-label]="getAriaLabel()">
    <canvas #QRCanvas aria-hidden="true"></canvas>
    <span class="visually-hidden">{{ getAriaLabel() }}</span>
</div>
